import * as React from 'react';

import {StreakEffectConfigurationContext, frameworkStreakEffect} from './streakeffectconfiguration';

const withStreakEffectConfiguration = <P extends object>(
    WrappedComponent: React.ComponentType<P>): React.FC<P> => {
    const HOC = (props: any): React.ReactElement => (
        <StreakEffectConfigurationContext.Consumer>
            {(auth: any): React.ReactElement => {
                return (
                    <WrappedComponent {...props}{...frameworkStreakEffect}/>
                );
            }}
        </StreakEffectConfigurationContext.Consumer>
    );

    HOC.displayName = `withAuthentication(${WrappedComponent.displayName || WrappedComponent.name})`;
    HOC.WrappedComponent = WrappedComponent;
    return HOC;
};

export default withStreakEffectConfiguration;